import { Inject, Injectable, NgZone, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../environments/environment';

declare const google: any;

@Injectable({
  providedIn: 'root'
})
export class GoogleIdentityService {

  private scriptPromise: Promise<void> | null = null;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private ngZone: NgZone
  ) {}

  loadScript(): Promise<void> {
    if (!isPlatformBrowser(this.platformId)) {
      return Promise.resolve();
    }
    if (this.scriptPromise) {
      return this.scriptPromise;
    }
    this.scriptPromise = new Promise<void>((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.defer = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Failed to load Google Identity Services script'));
      document.head.appendChild(script);
    });
    return this.scriptPromise;
  }

  async renderButton(container: HTMLElement, onCredential: (credential: string) => void): Promise<void> {
    if (!isPlatformBrowser(this.platformId) || !environment.socialLoginEnabled || !environment.googleClientId) {
      return;
    }
    await this.loadScript();
    google.accounts.id.initialize({
      client_id: environment.googleClientId,
      callback: (resp: any) => this.ngZone.run(() => onCredential(resp.credential))
    });
    google.accounts.id.renderButton(container, {
      theme: 'outline',
      size: 'large',
      width: 280,
      text: 'continue_with'
    });
  }
}
